import { RemittanceStatus, TaxRemittancesData } from "../dashboardOverview.types";

import { DashboardCard } from "./DashboardCard";
import { StatusBadge } from "./StatusBadge";
import { TaxIcon } from "./DashboardIcons";
import { formatCurrency } from "../dashboardFormat.utils";

export interface TaxRemittancesCardProps {
	data: TaxRemittancesData;
	onViewAll?: () => void;
}

const badgeToneByStatus: Record<RemittanceStatus, "warning" | "success" | "danger"> = {
	Scheduled: "warning",
	Submitted: "success",
	Overdue: "danger",
	"Due soon": "danger",
	Paid: "success",
};

export const TaxRemittancesCard = ({ data, onViewAll }: TaxRemittancesCardProps) => {
	return (
		<DashboardCard testId="tax-remittances-card">
			<div className="cd-card__header">
				<div className="cd-card__title">
					{/* <TaxIcon /> */}
					<h2>Remittances</h2>
				</div>
				<button type="button" className="cd-link-button" onClick={onViewAll}>
					All remittances
				</button>
			</div>
			<p className="cd-card__subtitle cd-remittances-outstanding">
				Outstanding: <strong>{formatCurrency(data.outstandingTotal, data.currency)}</strong>
			</p>

			<div className="cd-tax-table" role="table" aria-label="Remittances">
				{data.rows.map((row) => (
					<div className="cd-tax-table__row" role="row" key={row.id}>
						<div role="cell">
							<div className="cd-tax-table__authority">{row.authority}</div>
							<div className="cd-tax-table__description">{row.description} - {row.dateLabel}</div>
						</div>
						<div role="cell" className="cd-tax-table__amount">
							{formatCurrency(row.amount, row.currency)}
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<StatusBadge label={row.status} tone={badgeToneByStatus[row.status]} />
						</div>
					</div>
				))}
			</div>
		</DashboardCard>
	);
};
